import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupErrorProps as Props } from './types';

export const AdvancedTableSelectPopupError = memo(
  ({ className, errorText }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('AdvancedTableSelectPopupError', className)}
        sx={SX.root}
      >
        <Icon size={18} name="info-circle-outline" color="error" />

        <Typography variant="body4" color="error" fontWeight={400}>
          {errorText}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

AdvancedTableSelectPopupError.displayName = 'AdvancedTableSelectPopupError';
